import { render } from "./NewSingleWeb.vue?vue&type=template&id=8990fd6e&scoped=true"
import script from "./NewSingleWeb.vue?vue&type=script&lang=js"
export * from "./NewSingleWeb.vue?vue&type=script&lang=js"

import "./NewSingleWeb.vue?vue&type=style&index=0&id=8990fd6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8990fd6e"]])

export default __exports__